import { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';
import { useParams } from 'react-router';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import classNames from 'classnames';

// Components
import { LoadingCards } from 'components/LoadingCard';
import Button from 'components/Button/Button';

// Styles
import formStyles from '../FormStyles.module.scss';
import successFormStyles from './SuccessFormStyles.module.scss';

// Store + Core
import { currentBoardSelector, isLoadingBCTSelector } from 'store/bct/selectors';
import { getBoardById } from 'store/bct/actions';
import { ThunkDispatch } from 'redux-thunk';
import { PARSAction } from 'core/models';
import { AppState } from 'store';

// Types
import { IBCTBoard } from '../../types';

export const SuccessForm = (): ReactElement => {
  const dispatch: ThunkDispatch<AppState, unknown, PARSAction> = useDispatch();
  const { id } = useParams<{ id: string }>();

  // Selectors
  const currentBoard: IBCTBoard = useSelector(currentBoardSelector);
  const isLoading: boolean = useSelector(isLoadingBCTSelector);

  // Fetch.
  useEffect(() => {
    dispatch(getBoardById(id));
  }, [dispatch, id]);

  // Show this while data is loading.
  if (isLoading) return <LoadingCards />;

  return (
    <Box component="section">
      <div className={classNames(formStyles['form-card'], formStyles['success-page'])}>
        <h1 className={successFormStyles.title}>Board successfully updated</h1>
        <Box sx={{ mt: 4, mb: 4 }}>
          <Grid container spacing={4} sx={{ alignItems: 'center' }}>
            <Box component={Grid}>
              <CheckCircleIcon />
            </Box>
            <Grid size={{ xs: 11 }}>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Box component="div">
                  <strong>
                    {currentBoard.name} ({currentBoard.abbreviation})
                  </strong>
                </Box>
                <Box component="div">
                  ID: {currentBoard.id} | Integration Type {currentBoard.boardIntegrationType}
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
      <Box sx={{ display: 'flex', flexDirection: 'row-reverse' }}>
        <Button endIcon={<ArrowForwardRoundedIcon />} to="/" className="tertiary" title="go to dashboard" href={'/'}>
          Go to Dashboard
        </Button>
      </Box>
    </Box>
  );
};
